import { useRiskOverviewResponse } from "./useRiskOverviewResponse";

export const useBlockedBy = () => {
  const { blockList } = useRiskOverviewResponse();

  return {
    blockList,
  };
};
